import { memo } from 'react';

interface AndieIconProps {
    size?: number;
}

const AndieIconAnimated = memo(({ size = 32 }: AndieIconProps) => {
    return (
        <img
            src="/andie-icon-animated.webp"
            width={size}
            height={size}
            aria-hidden="true"
            style={{ display: 'block' }}
        />
    );
});

AndieIconAnimated.displayName = 'AndieIconAnimated';
export default AndieIconAnimated;
